const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const apiUrl = window.location.origin.includes('localhost') ? `http://localhost:7999/v1` : `${window.location.origin}/api/v1`;

export {
  clientID,
  apiUrl
};
